import { DisclosureTooltip, RatingTooltip } from '@ria-client/tw-shared-ui';
import { Info } from 'lucide-react';
import { NW_RATING_DEFAULT_TOOLTIP } from '../lib/financial-advisors/constants';
import type { DriverMappingConfig } from '../lib/financial-advisors/types';

export interface SummaryTableHeaderProps {
  drivers: DriverMappingConfig[];
  starRatingTooltip?: string;
}

export function SummaryTableHeader({ drivers, starRatingTooltip }: SummaryTableHeaderProps) {
  return (
    <thead className="sticky top-0 z-[1199] bg-white">
      <tr>
        <HeaderCell className="sticky left-[-1px] z-[1200] w-[190px] min-w-[190px] bg-white pl-0 md:relative lg:w-[200px]">
          Company
        </HeaderCell>
        <HeaderCell className="w-[130px] min-w-[130px] md:hidden">
          NerdWallet rating
          <RatingTooltip starRatingTooltip={starRatingTooltip ?? NW_RATING_DEFAULT_TOOLTIP} />
        </HeaderCell>
        {drivers.map(driver => (
          <HeaderCell key={driver.label} className="w-[190px] min-w-[130px]">
            {driver.label}
            {driver.tooltip ? (
              <DisclosureTooltip
                trigger={
                  <button
                    aria-label={`${driver.label} info`}
                    className="bg-transparent p-0"
                    type="button"
                  >
                    <Info aria-hidden size={15} />
                  </button>
                }
              >
                <span className="typography-text-small">{driver.tooltip}</span>
              </DisclosureTooltip>
            ) : null}
          </HeaderCell>
        ))}
        <HeaderCell className="hidden w-[159px] min-w-[170px] lg:table-cell lg:min-w-0">
          Learn more
        </HeaderCell>
      </tr>
    </thead>
  );
}

interface HeaderCellProps {
  children: React.ReactNode;
  className?: string;
}

function HeaderCell({ children, className }: HeaderCellProps) {
  return (
    <th
      scope="col"
      className={`border-b border-foreground p-4 pb-2 text-left text-base font-medium leading-6 ${className ?? ''}`}
    >
      <span className="flex items-center gap-1 whitespace-nowrap pr-2 text-[14px] md:whitespace-normal">
        {children}
      </span>
    </th>
  );
}
